import React from 'react';
import PropTypes from 'prop-types';
import ProfessionalGuardianLookupSection from '../../../../../features/bonds/shared/components/sections/ProfessionalGuardianLookupSection';
import { normalizeHistoricPgConfig } from '../../../../../features/bonds/shared/components/sections/pgSectionConfig';

export default function HistoricPgSection({ cfg, ...rest }) {
  return (
    <ProfessionalGuardianLookupSection
      {...rest}
      config={normalizeHistoricPgConfig(cfg)}
      isDisabled={false}
    />
  );
}

HistoricPgSection.propTypes = {
  index: PropTypes.number.isRequired,
  guardian: PropTypes.object.isRequired,
  guardians: PropTypes.array.isRequired,
  cfg: PropTypes.object.isRequired,
  professionalGuardians: PropTypes.array.isRequired,
  loadingGuardians: PropTypes.bool.isRequired,
  updateGuardianAt: PropTypes.func.isRequired,
  fetchProfessionalGuardianDetails: PropTypes.func.isRequired,
};
